
/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'house': {
    width: 13.3,
    height: 12.1,
    viewBox: '0 0 13.3 12.1',
    data: '<path pid="0" d="M10.2 2.7L7.1.2c-.3-.2-.7-.2-.9 0L.5 4.9C-.3 5.5-.1 6 .9 6H2v5.4c0 .3.3.6.6.6h8.2c.3 0 .6-.3.6-.6V6h1c1 0 1.2-.5.4-1.2l-1.4-1.2V2.4c0-.3-.3-.6-.6-.6s-.6.3-.6.6v.3z"/>'
  }
})
